export default {
  countryWrapper:
    'countryWrapper fixed inset-0 bg-alpha-black-50 z-40 overflow-y-auto items-center justify-center h-screen',
  countryContent:
    'country-selector-dialog modal-dialog relative bg-white w-12/12 my-50 lg:mt-80 mx-auto p-20 lg:p-40 md:text-center dialog-extra-style',
  countrySectionsWrapper:
    ' w-7/12 md:w-11/12 lg:w-11/12 mx-auto lg:mb-20 pb-20 country-wrapper flex flex-wrap flex-col text-left',
  countrySections: 'mb-50 md:w-25p',
  countryTitleHeader:
    'countryHeader text-center font-HelveticaNeueMedium text-20 pb-50 pt-15',
  countryHeader: 'countryHeader font-HelveticaNeueBold pb-15',
  countryText:
    'countryText py-2 text-12 lg:text-14 float-left clearfix font-HelveticaNeueLight block w-full text-black no-underline',
  countryShow: 'countryShow',
  countryHide: 'countryHide hidden',
  countryCloseBtn: 'country-close',
};
